// LoadingPage.js
import React from "react";

const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingPage;
